import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    query: '',
    typeQuery: [],
    zoom: undefined,
    center: undefined,
  },
  getters: {
    getQuery: function (state) {
      console.log('store.index.mutations.get-query', state.query)

      return state.query
    },
    getTypeQuery: function (state) {
      return state.typeQuery
    },
    getZoom: function (state) {
      return state.zoom
    },
    getCenter: function (state) {
      return state.center
    },
  },
  mutations: {
    setQuery(state, query) {
      state.query = query
      console.log('store.index.mutations.set-query', state.query)
    },
    setTypeQuery(state, typeQuery) {
      state.typeQuery = typeQuery
    },
    setZoom(state, zoom) {
      state.zoom = zoom
    },
    setCenter(state, center) {
      state.center = center
    },
  },
  actions: {},
  modules: {},
})
